import type { role } from "@agentcall/core/type/admin_type"
import { atom } from "jotai"
import { atomWithStorage } from "jotai/utils"

export interface User {
  id: string
  email: string
  name: string
  role: role
}

// ユーザー情報とトークンをlocalStorageに永続化
export const userAtom = atomWithStorage<User | null>("auth-user", null)
export const tokenAtom = atomWithStorage<string | null>("auth-token", null)

// 認証状態を派生atom として定義
export const isAuthenticatedAtom = atom((get) => {
  const user = get(userAtom)
  const token = get(tokenAtom)
  return !!(user && token)
})

// ログイン処理用のatomアクション
export const loginAtom = atom(null, (_get, set, { user, token }: { user: User; token: string }) => {
  localStorage.setItem("auth-token", token)
  set(userAtom, user)
  set(tokenAtom, token)
})

// ログアウト処理用のatomアクション
export const logoutAtom = atom(null, (_get, set) => {
  localStorage.removeItem("auth-token")
  set(userAtom, null)
  set(tokenAtom, null)
})
